import { render, staticRenderFns } from "./OurCoaches.vue?vue&type=template&id=4a449336"
import script from "./OurCoaches.vue?vue&type=script&lang=js"
export * from "./OurCoaches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports